export var colorNeutral = "#000000";
export var distance100Alpha = 0.25;
export var distance100AOffsetX = "0px";
export var distance100AOffsetY = "0.4px";
export var distance100ABlurRadius = "0.5px";
export var distance100ASpreadRadius = "0px";
export var distance100AColor = "#000000";
export var distance100AOpacity = 0.25;
export var distance100BOffsetX = "0px";
export var distance100BOffsetY = "0.6px";
export var distance100BBlurRadius = "0.7px";
export var distance100BSpreadRadius = "-1.2px";
export var distance100BColor = "#000000";
export var distance100BOpacity = 0.25;
export var distance100COffsetX = "0px";
export var distance100COffsetY = "1.4px";
export var distance100CBlurRadius = "1.6px";
export var distance100CSpreadRadius = "-2.5px";
export var distance100CColor = "#000000";
export var distance100COpacity = 0.25;
export var distance100DOffsetX = "0px";
export var distance100DOffsetY = "0px";
export var distance100DBlurRadius = "2.8px";
export var distance100DSpreadRadius = "-1.2px";
export var distance100DColor = "#000000";
export var distance100DOpacity = 0.2;
export var distance200Alpha = 0.25;
export var distance200AOffsetX = "0px";
export var distance200AOffsetY = "0.1px";
export var distance200ABlurRadius = "0.1px";
export var distance200ASpreadRadius = "0px";
export var distance200AColor = "#000000";
export var distance200AOpacity = 0.25;
export var distance200BOffsetX = "0px";
export var distance200BOffsetY = "0.4px";
export var distance200BBlurRadius = "0.5px";
export var distance200BSpreadRadius = "-0.7px";
export var distance200BColor = "#000000";
export var distance200BOpacity = 0.25;
export var distance200COffsetX = "0px";
export var distance200COffsetY = "1.1px";
export var distance200CBlurRadius = "1.2px";
export var distance200CSpreadRadius = "-1.5px";
export var distance200CColor = "#000000";
export var distance200COpacity = 0.25;
export var distance200DOffsetX = "0px";
export var distance200DOffsetY = "2.7px";
export var distance200DBlurRadius = "3.2px";
export var distance200DSpreadRadius = "-2px";
export var distance200DColor = "#000000";
export var distance200DOpacity = 0.25;
export var distance200EOffsetX = "0px";
export var distance200EOffsetY = "-0.1px";
export var distance200EBlurRadius = "1.2px";
export var distance200ESpreadRadius = "0px";
export var distance200EColor = "#000000";
export var distance200EOpacity = 0.1;
export var distance200FOffsetX = "0px";
export var distance200FOffsetY = "0px";
export var distance200FBlurRadius = "3.5px";
export var distance200FSpreadRadius = "-2.2px";
export var distance200FColor = "#000000";
export var distance200FOpacity = 0.2;
export var distance300Alpha = 0.07;
export var distance300AOffsetX = "0px";
export var distance300AOffsetY = "0.4px";
export var distance300ABlurRadius = "0.5px";
export var distance300ASpreadRadius = "0px";
export var distance300AColor = "#000000";
export var distance300AOpacity = 0.07;
export var distance300BOffsetX = "0px";
export var distance300BOffsetY = "1.2px";
export var distance300BBlurRadius = "1.3px";
export var distance300BSpreadRadius = "-0.8px";
export var distance300BColor = "#000000";
export var distance300BOpacity = 0.07;
export var distance300COffsetX = "0px";
export var distance300COffsetY = "2.9px";
export var distance300CBlurRadius = "3.3px";
export var distance300CSpreadRadius = "-1.7px";
export var distance300CColor = "#000000";
export var distance300COpacity = 0.07;
export var distance300DOffsetX = "0.1px";
export var distance300DOffsetY = "6.9px";
export var distance300DBlurRadius = "7.8px";
export var distance300DSpreadRadius = "-2.5px";
export var distance300DColor = "#000000";
export var distance300DOpacity = 0.07;
export var distance300EOffsetX = "0px";
export var distance300EOffsetY = "0px";
export var distance300EBlurRadius = "7.8px";
export var distance300ESpreadRadius = "-2.5px";
export var distance300EColor = "#000000";
export var distance300EOpacity = 0.1;
export var distance400Alpha = 0.05;
export var distance400AOffsetX = "0px";
export var distance400AOffsetY = "0.4px";
export var distance400ABlurRadius = "0.5px";
export var distance400ASpreadRadius = "0px";
export var distance400AColor = "#000000";
export var distance400AOpacity = 0.05;
export var distance400BOffsetX = "0px";
export var distance400BOffsetY = "1.8px";
export var distance400BBlurRadius = "2px";
export var distance400BSpreadRadius = "-0.4px";
export var distance400BColor = "#000000";
export var distance400BOpacity = 0.05;
export var distance400COffsetX = "0px";
export var distance400COffsetY = "3.3px";
export var distance400CBlurRadius = "3.7px";
export var distance400CSpreadRadius = "-0.7px";
export var distance400CColor = "#000000";
export var distance400COpacity = 0.05;
export var distance400DOffsetX = "0.1px";
export var distance400DOffsetY = "5.3px";
export var distance400DBlurRadius = "6px";
export var distance400DSpreadRadius = "-1.1px";
export var distance400DColor = "#000000";
export var distance400DOpacity = 0.05;
export var distance400EOffsetX = "0.1px";
export var distance400EOffsetY = "8.4px";
export var distance400EBlurRadius = "9.5px";
export var distance400ESpreadRadius = "-1.4px";
export var distance400EColor = "#000000";
export var distance400EOpacity = 0.05;
export var distance400FOffsetX = "0.1px";
export var distance400FOffsetY = "13.1px";
export var distance400FBlurRadius = "14.7px";
export var distance400FSpreadRadius = "-1.8px";
export var distance400FColor = "#000000";
export var distance400FOpacity = 0.05;
export var distance400GOffsetX = "0.2px";
export var distance400GOffsetY = "19.9px";
export var distance400GBlurRadius = "22.4px";
export var distance400GSpreadRadius = "-2.1px";
export var distance400GColor = "#000000";
export var distance400GOpacity = 0.05;
export var distance400HOffsetX = "0.3px";
export var distance400HOffsetY = "29.3px";
export var distance400HBlurRadius = "33px";
export var distance400HSpreadRadius = "-2.5px";
export var distance400HColor = "#000000";
export var distance400HOpacity = 0.05;
export var distance400IOffsetX = "0px";
export var distance400IOffsetY = "0px";
export var distance400IBlurRadius = "9.5px";
export var distance400ISpreadRadius = "-1.4px";
export var distance400IColor = "#000000";
export var distance400IOpacity = 0.075;
export var distance500OffsetX = "0px";
export var distance500OffsetY = "2px";
export var distance500BlurRadius = "6px";
export var distance500SpreadRadius = "0px";
export var distance500Color = "#767676";
export var distance500Opacity = 0.4;
export var distance600OffsetX = "0px";
export var distance600OffsetY = "4px";
export var distance600BlurRadius = "8px";
export var distance600SpreadRadius = "0px";
export var distance600Color = "#767676";
export var distance600Opacity = 0.4;
export var glowPrimaryOffsetX = "0px";
export var glowPrimaryOffsetY = "0px";
export var glowPrimaryBlurRadius = "8px";
export var glowPrimarySpreadRadius = "0px";
export var glowPrimaryColor = "#2277d1";
export var glowPrimaryOpacity = 0.2;
export var glowDangerOffsetX = "0px";
export var glowDangerOffsetY = "0px";
export var glowDangerBlurRadius = "8px";
export var glowDangerSpreadRadius = "0px";
export var glowDangerColor = "#b41522";
export var glowDangerOpacity = 0.2;
export var ringPrimaryOffsetX = "0px";
export var ringPrimaryOffsetY = "0px";
export var ringPrimaryBlurRadius = "0px";
export var ringPrimarySpreadRadius = "2px";
export var ringPrimaryColor = "#2277d1";
export var ringPrimaryOpacity = 0.3;
export var ringNeutralOffsetX = "0px";
export var ringNeutralOffsetY = "0px";
export var ringNeutralBlurRadius = "0px";
export var ringNeutralSpreadRadius = "2px";
export var ringNeutralColor = "#767676";
export var ringNeutralOpacity = 0.2;
export var haloNeutralOffsetX = "0px";
export var haloNeutralOffsetY = "0px";
export var haloNeutralBlurRadius = "0px";
export var haloNeutralSpreadRadius = "3px";
export var haloNeutralColor = "#767676";
export var haloNeutralOpacity = 0.3;
export var haloPrimaryOffsetX = "0px";
export var haloPrimaryOffsetY = "0px";
export var haloPrimaryBlurRadius = "0px";
export var haloPrimarySpreadRadius = "3px";
export var haloPrimaryColor = "#2277d1";
export var haloPrimaryOpacity = 0.3;
export var haloWarningOffsetX = "0px";
export var haloWarningOffsetY = "0px";
export var haloWarningBlurRadius = "0px";
export var haloWarningSpreadRadius = "3px";
export var haloWarningColor = "#ffa100";
export var haloWarningOpacity = 0.3;
export var haloSuccessOffsetX = "0px";
export var haloSuccessOffsetY = "0px";
export var haloSuccessBlurRadius = "0px";
export var haloSuccessSpreadRadius = "3px";
export var haloSuccessColor = "#1c7a09";
export var haloSuccessOpacity = 0.3;
export var haloDangerOffsetX = "0px";
export var haloDangerOffsetY = "0px";
export var haloDangerBlurRadius = "0px";
export var haloDangerSpreadRadius = "3px";
export var haloDangerColor = "#b41522";
export var haloDangerOpacity = 0.3;